module.exports = __webpack_public_path__ + "assets/img/091e-sn.svg";